import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	isDevMode,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { CmvHttpEntidadResponse } from 'src/app/models/apis/entities';
import { CmvfinanzasregistroService } from 'src/app/services/apis/cmvfinanzasregistro.service';
import {
	OtpRequestCode,
	OtpRequestValidateCode,
} from 'src/app/models/apis/otp.model';
import {
	AbstractControl,
	FormBuilder,
	FormGroup,
	Validators,
} from '@angular/forms';
import { MonitoringService } from 'src/app/services/monitoring/monitoring.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { PreauthorizedOffer } from 'src/app/models/state/preauthorized-offer.model';
import { selectOfferDataState } from 'src/app/state/selectors/preauthorized-offer.selector';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/appState.state';
import { environment } from 'src/environments/environment';

type EnterCodeNotifyAction =
	| 'OTP RESEND'
	| 'OTP NOT RECEIVED'
	| 'OTP SENT'
	| 'OTP ERROR SEND';

@Component({
	selector: 'cmv-enter-code',
	templateUrl: './enter-code.component.html',
	styleUrls: ['./enter-code.component.scss'],
})
export class EnterCodeComponent implements OnInit {
	@Input()
	memberNumber: number = 0;
	@Input() phoneNumber: string;
	@Input() enterCodeLength: number = 6;
	@Input() isMember: boolean;
	@Input() skipInternalValidation: boolean = false;
	@Output()
	successEnterCode: EventEmitter<string> = new EventEmitter();
	@Output()
	errorEnterCode: EventEmitter<string> = new EventEmitter();
	@Output()
	generateOtpSuccess: EventEmitter<string> = new EventEmitter();
	@ViewChild('otpInput', { read: ElementRef }) enterCodeInput: ElementRef;

	endCelNumber: string;
	intentos: number = 3;
	enterCodeForm: FormGroup;
	isOtpValidated: boolean = false;
	otpForwardingTimeout: number = 0;
	interval: any;
	otpForwardingAttempt: number = 1;
	isOtpValidating: boolean = false;
	notReceivedOtpButtonHasBeenClicked: boolean = false;
	isOtpSending: boolean = false;
	offerDataState$: Observable<PreauthorizedOffer> =
		this.store.select(selectOfferDataState);
	personId: number;

	constructor(
		private _apiCmvFinanzasRegistro: CmvfinanzasregistroService,
		private formBuilder: FormBuilder,
		private monitoringService: MonitoringService,
		private utilsService: UtilsService,
		private store: Store<AppState>
	) {
		this.offerDataState$.subscribe(data => {
			if (data) {
				this.personId = data.offerPersonId;
			}
		});
	}

	get endPhoneNumber(): string {
		return this.phoneNumber?.substring(this.phoneNumber.length - 3);
	}

	get mensajeReenviar(): string {
		return this.otpForwardingTimeout > 0
			? `Espere ${this.otpForwardingTimeout} segundos`
			: 'Reenviar el código';
	}

	get isOtpNotReceivedButonEnabled(): boolean {
		return this.otpForwardingTimeout <= 0;
	}

	ngOnInit(): void {
		this.sendOpt();
		this.inititalizeEnterCodeForm();
	}

	private inititalizeEnterCodeForm() {
		const pattern = new RegExp(`^\\d{${this.enterCodeLength}}$`);
		this.enterCodeForm = this.formBuilder.group({
			enterCode: ['', [Validators.required, Validators.pattern(pattern)]],
		});
	}

	get enterCodeField(): AbstractControl {
		return this.enterCodeForm.get('enterCode');
	}

	startCountdown(): void {
		this.otpForwardingTimeout = 80;
		this.interval = setInterval(() => {
			if (this.otpForwardingTimeout <= 0) {
				clearInterval(this.interval);
			}
			this.otpForwardingTimeout -= 1;
		}, 1000);
	}

	onKeyupEnterCode(): void {
		if (this.isOtpValidating || this.isOtpValidated) {
			return;
		}
		if (this.enterCodeField.invalid) {
			return;
		}
		this.sendValidateOtp();
	}

	sendValidateOtp() {
		if (this.skipInternalValidation) {
			this.isOtpValidating = true;
			this.enterCodeField.disable();
			this.successEnterCode.emit(String(this.enterCodeField.value));
			return;
		}
		const postData: OtpRequestValidateCode = {
			id_socio: this.getPersonId(),
			otp: this.enterCodeField.value,
			tipo_medio: 4,
		};
		this.validateOtpTDC(postData);
	}

	markAsValidated(): void {
		this.isOtpValidating = false;
		this.isOtpValidated = true;
	}

	resetAfterExternalValidationError(): void {
		this.isOtpValidating = false;
		this.intentos = this.intentos - 1;
		this.resetEnterCodeForm();
		this.focusOtpInput();
	}

	validateOtpTDC(data: OtpRequestValidateCode) {
		this.isOtpValidating = true;
		this.enterCodeField.disable();
		this._apiCmvFinanzasRegistro.validateOtpTDC(data).subscribe({
			next: (response: { status: boolean; body: any }) => {
				this.isOtpValidating = false;
				console.log('comp', response);
				if (response.status) {
					this.isOtpValidated = true;
					this.successEnterCode.emit(this.enterCodeField.value);
				} else {
					this.resetEnterCodeForm();
					this.focusOtpInput();
					this.errorEnterCode.emit(
						response.body.detail
							? response.body.message
							: 'Código de verificación incorrecto'
					);
				}
			},
			error: error => {
				this.isOtpValidating = false;
				this.intentos = this.intentos - 1;
				this.resetEnterCodeForm();
				this.focusOtpInput();
				if (error.body.detail) {
					this.errorEnterCode.emit(error.body.detail);
				} else {
					this.errorEnterCode.emit('Solicita un nuevo codigo de verificación');
				}
			},
		});
	}

	private focusOtpInput() {
		this.enterCodeInput.nativeElement.querySelector('input').focus();
	}

	resetEnterCodeForm(): void {
		this.enterCodeField.enable();
		this.enterCodeField.setValue('');
	}

	onReSendOptCode() {
		this.notifyMonitoringTool('OTP RESEND');
		if (this.otpForwardingTimeout <= 0) {
			this.sendOpt();
			this.resetEnterCodeForm();
		}
	}

	onNotifyOtpNoReceived(): void {
		this.notifyMonitoringTool('OTP NOT RECEIVED');
		this.utilsService.ShowToast('Reporte enviado');
		this.notReceivedOtpButtonHasBeenClicked = true;
	}

	getPersonId(): number {
		return this.personId;
	}

	sendOpt() {
		const otpRequestCode: OtpRequestCode = {
			id_socio: this.getPersonId(),
			tipo_medio: 4,
		};
		this.generateOtpTDC(otpRequestCode);
		this.startCountdown();
		this.incrementOtpForwardingAttempt();
	}

	incrementOtpForwardingAttempt() {
		this.otpForwardingAttempt++;
	}

	generateOtpTDC(data: OtpRequestCode) {
		this.isOtpSending = true;
		this._apiCmvFinanzasRegistro.generateOtpTDC(data).subscribe({
			next: (response: boolean) => {
				this.isOtpSending = false;
				this.notifyMonitoringTool('OTP SENT', { wasSent: response });
				if (response) {
					this.generateOtpSuccess.emit(
						data.tipo_medio === 2
							? 'Código enviado via WhatsApp'
							: 'Se ha enviado correctamente el código de verificación'
					);
				}
			},
			error: (err: Error) => {
				this.isOtpSending = false;
				this.notifyMonitoringTool('OTP ERROR SEND', { error: err.message });
				this.errorEnterCode.emit(err.message);
			},
		});
	}

	shouldSendNotificationByWhatsApp(attemptNumber: number): boolean {
		return attemptNumber > 0 && attemptNumber % 2 !== 0;
	}

	private notifyMonitoringTool(
		notifyAction: EnterCodeNotifyAction,
		extraTags?: { [key: string]: unknown }
	): void {
		const tags = {
			otpForwardingTimeout: this.otpForwardingTimeout,
			otpForwardingAttempt: this.otpForwardingAttempt,
		};
		this.monitoringService.captureAction(notifyAction, { ...tags, extraTags });
	}
}
